// extracted by mini-css-extract-plugin
module.exports = {"form":"styles_form__3B8ug","row":"styles_row__2a2Z5"};